import { createSelector } from 'reselect';
import { ROLES } from '@config/authentication';

export const selectAuthentication = (state) => state.authentication;

export const selectUserId = createSelector(
  selectAuthentication,
  ({ userId }) => userId,
);
export const selectPermission = (state) => selectAuthentication(state).permission;
export const tokenSelector = (state) => selectAuthentication(state).token;
export const otpSelector = (state) => selectAuthentication(state).otp;
export const isSuperAdmin = (state) => selectPermission(state) === ROLES.SUPER_ADMIN;
export const isAnalyst = (state) => selectPermission(state) === ROLES.ANALYST;
export const isAttendee = (state) => selectPermission(state) === ROLES.ATTENDEE;
export const isRoleLoading = (state) => selectAuthentication(state).rolesLoading;
export const twoFactorAuthBlocked = (state) =>
  selectAuthentication(state).twoFactorAuthBlocked;
export const twoFactorAuthAttemptsCountExhausted = (state) =>
  selectAuthentication(state).attemptsCountExhausted;
export const isResetingPassword = (state) =>
  selectAuthentication(state).isResetingPassword;



// WEBPACK FOOTER //
// ./redux/selectors/authentication.js